import React, { Component } from 'react';
import classnames from 'classnames';
import { Link } from 'react-router';
import './style.css';

class TeacherNavLink extends Component {
  render() {
    const {
      title, icon, className, active, hideText, submenu, ...otherProps
    } = this.props;
    return (
      <Link
        className={classnames(
          'd-block',
          'teacher-nav-link',
          'px-4',
          { [className]: className },
          { active },
          { submenu }
        )}
        {...otherProps}
      >
        <div className="teacher-nav-link__content d-flex">
          {icon && <img alt={icon} src={`/assets/teacher/${icon}.png`} />}
          {!hideText && <p className="ml-4 mb-0">{title}</p>}
        </div>
      </Link>
    );
  }
}

export default TeacherNavLink;



// WEBPACK FOOTER //
// ./src/components/navigation/TeacherNavLink/index.js